export default "__VITE_ASSET__DTY9LaPT__"